import Swal from 'sweetalert2';

export class SweetAlert {
  swalMessage(title: string, msg: string) {
    Swal.fire(title, msg, 'info');
  }

  swalWarning(msg: string) {
    Swal.fire('Warning!', msg, 'warning');
  }

  swalError(msg: string) {
    Swal.fire('เกิดข้อผิดพลาด!', msg, 'error');
  }

  swalStandardError(resultDescription: string, developMessage: string) {
    Swal.fire({
      icon: 'error',
      title: resultDescription,
      html: `
        <p id="showText">Click to show/hide details</p>
        <p id="detailText" style="display: none;">${developMessage}</p>
      `,
      confirmButtonText: 'OK',
      didOpen: this.didOpen,
    });
  }

  didOpen() {
    const sweetAlertPopup = Swal.getPopup();
    if (sweetAlertPopup) {
      sweetAlertPopup.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (target.id === 'showText') {
          const detailText = document.getElementById('detailText');
          if (detailText && detailText.style.display === 'none') {
            detailText.style.display = 'block';
          } else if (detailText) {
            detailText.style.display = 'none';
          }
        }
      });
    }
  }

  swalError2(errorMsg: string, errorDetail: string) {
    Swal.fire({
      icon: 'error',
      title: errorMsg,
      text: errorDetail,
    });
  }

  swalInfo(msg: string) {
    Swal.fire('Info!', msg, 'info');
  }

  swalSuccess(msg: string) {
    Swal.fire('Finish!', msg, 'success');
  }
  error(msg: string, html?:any) {
    return Swal.fire({
      icon: "error",
      title: "Error",
      confirmButtonColor: '#cced61',
      confirmButtonText: '<div style="color:#546e7a">OK</div>',
      text: msg,
      html:html
    });
  }
  warning(msg: string, html?:any) {
    return Swal.fire({
      icon: "warning",
      text: msg,
      confirmButtonColor: '#cced61',
      html:html
    });
  }
  success(msg: string) {
    return Swal.fire({
      icon: "success",
      // title: "Success",
      confirmButtonColor: '#cced61',
      confirmButtonText: '<div style="color:#546e7a">OK</div>',
      text: msg
    });
  }
  question(msg:string, html?:any){
    return Swal.fire({
      icon: "question",
      // title: "Are you sure?",
      showCancelButton: true,
      cancelButtonColor: '#d5d5d5',
      confirmButtonColor: '#cced61',
      cancelButtonText: '<div style="color:#546e7a"> Cancel </div>',
      confirmButtonText: '<div style="color:#546e7a"> Confirm </div>',
      html:html,
      text: msg,
      reverseButtons:true
    });
  }

  info(msg: string, html?:any) {
    return Swal.fire({
      // icon: "info",
      text: msg,
      confirmButtonColor: '#cced61',
      html:html
    });
  }

  notify(data:any){
    return Swal.fire(data);
  }

  close(){
    return Swal.close();
  }
  //#endregion
}
